import React, { useState, useRef } from 'react';
import ArchiveRowProduct from '../product/ArchiveRowProduct';
import Excel from '@/app/_components/ui/icons/Excel.svg';
import Print from '@/app/_components/ui/icons/Print.svg';
import PdfInvoice from '@/app/_components/ui/icons/PdfInvoice.svg';
import moment from 'jalali-moment';
import { useReactToPrint } from 'react-to-print';

export default function ArchiveContentList({
  products,
  priorityProducts,
  pageTitle = '',
}) {
  const now = moment();
  const printRef = useRef();
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [isGeneratingPdf, setIsGeneratingPdf] = useState(false);

  /**
   * ------------------------------------------------------------------------------------------------
   * Toggle select all products
   * ------------------------------------------------------------------------------------------------
   */
  const handleSelectedAllItems = (e) => {
    if (e.target.checked) {
      setSelectedProducts([...products, priorityProducts]);
    } else {
      setSelectedProducts([]);
    }
  };
  /**
   * ------------------------------------------------------------------------------------------------
   * Hanlder to just print the table
   * ------------------------------------------------------------------------------------------------
   */
  const handlePrint = useReactToPrint({
    content: () => printRef.current,
    documentTitle: 'Selected Products',
  });

  /**
   * ------------------------------------------------------------------------------------------------
   * Hanlder to get pdf
   * ------------------------------------------------------------------------------------------------
   */
  const handlerGetPdf = async () => {
    if (selectedProducts.length > 0 || products.length > 0) {
      setIsGeneratingPdf(true);
      try {
        const response = await fetch('/api/generate-price-list-pdf', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            products: selectedProducts.length > 0 ? selectedProducts : products,
            title: pageTitle,
          }),
        });
        if (!response.ok) {
          throw new Error('Failed to generate PDF');
        }
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `${pageTitle || 'price-list'}.pdf`;
        a.click();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error('Error generating invoice:', error);
      }
      setIsGeneratingPdf(false);
    }
  };
  /**
   * ------------------------------------------------------------------------------------------------
   * Hanlder to get Excel
   * ------------------------------------------------------------------------------------------------
   */
  const handlerGetExcel = async () => {
    if (selectedProducts.length > 0 || products.length > 0) {
      setIsGeneratingPdf(true);
      try {
        const response = await fetch('/api/generate-price-list-excel', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            products: selectedProducts.length > 0 ? selectedProducts : products,
            title: pageTitle,
          }),
        });
        if (!response.ok) {
          throw new Error('Failed to generate Excel');
        }
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `${pageTitle || 'price-list'}.xlsx`;
        a.click();

        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error('Error generating Excel:', error);
      }
      setIsGeneratingPdf(false);
    }
  };

  /**
   * ------------------------------------------------------------------------------------------------
   * Toggle select products
   * ------------------------------------------------------------------------------------------------
   */
  const toggleSelectProduct = (productId) => {
    setSelectedProducts((prevSelected) => {
      const isSelected = prevSelected.some(
        (product) => product.id === productId
      );

      if (isSelected) {
        return prevSelected.filter((product) => product.id !== productId);
      } else {
        const productToAdd = products.find(
          (product) => product.id === productId
        );
        return [...prevSelected, productToAdd];
      }
    });
  };
  /**
   * ------------------------------------------------------------------------------------------------
   * check if product Selected
   * ------------------------------------------------------------------------------------------------
   */
  const isProductSelected = (product) =>
    selectedProducts.some((selected) => selected.id === product.id);

  return (
    <div ref={printRef} className="wrap-print">
      <div className="flex justify-between border border-light-gray-150 p-2 mb-3 rounded-md leading-6">
        <div className="flex gap-4 text-xs font-semibold ">
          <div className="text-gray-400">{`لیست قیمت ${pageTitle}`}</div>
          <div className="text-color-primary ">
            <span className="hidden sm:inline-block">به تاریخ </span>
            {`${now.locale('fa').format('YYYY/MM/DD')} `}
          </div>
        </div>
        <div className="flex gap-1 sm:gap-4 text-xs text-gray-400 font-bold no-print ">
          <div className="hidden sm:inline-block">دریافت خروجی</div>
          <button onClick={handlePrint}>
            <Print />
          </button>
          <button onClick={handlerGetPdf}>
            <PdfInvoice fill="#FC2254" />
          </button>
          <button onClick={handlerGetExcel}>
            <Excel />
          </button>
        </div>
      </div>
      <table className="w-full rounded-lg overflow-hidden">
        <thead className="hidden sm:table-row-group">
          <tr className="font-semibold text-xs leading-12 bg-light-gray-100  border border-light-gray-300 ">
            <td className="pr-4 hidden sm:table-cell t no-print">
              <input
                type="checkbox"
                className="border border-light-gray-900 rounded-sm ml-3 w-4 h-4"
                onChange={handleSelectedAllItems}
              />
              انتخاب
            </td>
            <td>برند</td>
            <td>نام محصول</td>
            <td>قیمت (تومان)</td>
            <td>موجودی </td>
            <td className="no-print">خرید</td>
            <td className="no-print">پیش فاکتور</td>
          </tr>
        </thead>
        <tbody>
          {products.length > 0 ? (
            products.map((product, index) => (
              <ArchiveRowProduct
                key={product.id}
                product={product}
                index={index}
                selected={isProductSelected(product)}
                toggleSelectProduct={toggleSelectProduct}
              />
            ))
          ) : (
            <div className="w-full">
              <p className="text-center block">نتیجه‌ای یافت نشد!</p>
            </div>
          )}
        </tbody>
      </table>
    </div>
  );
}
